// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__Smm88","modalForm":"UpgradeEpcsModal_modalForm__2uQXr","modalFooter":"UpgradeEpcsModal_modalFooter__1fwFn"};